<div class="grid-gap-x6">
  <adex-dynamic-form
    (validForm)="validForm$.next($event)"
    [model]="model"
    (changeForm)="onChangeForm($event)"
  ></adex-dynamic-form>

  <div class="grid-button-container">
    <button
      nz-button
      nzType="default"
      routerLink="/auth/login"
    >{{'CANCEL' | translate}}</button>
    <button
      (click)="onSubmit()"
      [disabled]="disabledButton$ | async"
      nz-button
      nzType="primary"
    >{{'SEND' | translate}}</button>
  </div>

</div>
